// import { selectActionText } from 'utilities/constants';
import { getRandomUid } from 'utilities/uuid.service';
import Select from 'react-select';

function ReviewContent(props) {
  const { area, value, onChange, disableList = [], selectProps = {}, reviewOptions } = props;
  if (!area) return null;

  if (!Array.isArray(area?.reviewOptions) && !reviewOptions) return null;

  const _id = getRandomUid();

  const __reviewOptions =
    (area?.reviewOptions || reviewOptions)?.map?.((option) => {
      // const _uid = getRandomUid();
      option.isDisabled = option.isDisabled || disableList.includes(option.value) || false;
      return option;
    }) || [];

  return (
    <>
      <label htmlFor={_id}>Status</label>
      <Select
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
        }}
        inputId={_id}
        className="basic-single"
        classNamePrefix="select"
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isSearchable={false}
        name="ReviewContentDP"
        options={__reviewOptions}
        value={__reviewOptions?.find?.((x) => x.value === value)}
        onChange={(args) => {
          onChange(args?.value || null);
        }}
      />
    </>
  );
  // return (
  //   <>
  //     <label>Status</label>
  //     <select
  //       {...selectProps}
  //       value={value}
  //       onChange={(event) => onChange(event.target.value, event)}
  //     >
  //       <option value="">{selectActionText}</option>
  //       {area?.reviewOptions && Array.isArray(area?.reviewOptions) ? (
  //         area?.reviewOptions?.map?.((option) => {
  //           const _uid = getRandomUid();
  //           const disabled = option.isDisabled || disableList.includes(option.value) || false;
  //           return (
  //             <option key={_uid} value={option.value} disabled={disabled}>
  //               {option.label}
  //             </option>
  //           );
  //         })
  //       ) : (
  //         <option value="draft">No options found</option>
  //       )}
  //     </select>
  //   </>
  // );
}

export default ReviewContent;
